// extracted by mini-css-extract-plugin
export default {"projectName":"NameWithCompleteCheckbox_projectName__a0N+S"};